import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {
      boxSize: '4',
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
    },
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, beta.200, beta.400)',
    color: 'alpha.600',
    borderRadius: 'sm',
    border: 'none',
    h: 10,
    w: 'auto',
    minW: '4',
    cursor: 'pointer',
    _hover: {
      bgGradient: 'linear(to-b, beta.300, beta.400)',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {
      boxSize: '4',
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.45)',
    },
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, beta.200, beta.400)',
    color: 'alpha.600',
    borderRadius: 'sm',
    border: 'none',
    h: 10,
    w: 'auto',
    minW: '4',
    cursor: 'pointer',
    _hover: {
      bgGradient: 'linear(to-b, beta.300, beta.400)',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.600',
    borderRadius: 'md',
    boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  buttonGroupSports: {
    borderRadius: 'lg',
    display: 'inline-flex',
    flex: '1',
    overflowX: 'auto',
    p: '1',
    spacing: '1',
    whiteSpace: 'nowrap',
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    borderRightRadius: 'md',
    pl: '1',
    py: '0.5',
    pr: '1',
    spacing: '1',
    gap: '0.5',
    bg: 'none',
    isAttached: true,
    alignItems: 'center',
  },
  scrollIndicator: {
    w: 2,
    h: '0.5',
    bg: 'epsilon.500',
    pos: 'absolute',
    bottom: 'px',
    transition: 'all 0.2s ease',
  },
};
